import { SlideColorBubbleType } from 'components/Common/SlideColorBubbles/SlideColorBubbles';
import { ProductColorsType } from 'types/ProductPageV2/Products';

export function formatColors(
  colors: ProductColorsType[],
  editUrl = ''
): SlideColorBubbleType[] {
  return colors.map(c => {
    const { couleur, pastille, url } = c;
    const [baseUrl, hash] = url.split('#');

    return {
      color: couleur,
      image: pastille,
      url: hash ? `${baseUrl}${editUrl}#${hash}` : `${url}${editUrl}`,
    };
  });
}
